export default "__VITE_ASSET__8a6df174__"